import BookWithBookmarkIcon from '@atlaskit/icon/core/book-with-bookmark';
import CompassIcon from '@atlaskit/icon/core/compass';
import CreditCardIcon from '@atlaskit/icon/core/credit-card';
import CustomizeIcon from '@atlaskit/icon/core/customize';
import ProjectIcon from '@atlaskit/icon/core/project';
import SupportIcon from '@atlaskit/icon/core/support';
import BookOpenIcon from '@atlaskit/icon-lab/core/book-open';
import RoadmapsPlanIcon from '@atlaskit/icon-lab/core/roadmaps-plan';

import { messages } from './messages';
import { ResourceLinkCardProps } from './types';

export enum TAB_KEYS {
	ALL = 'all',
	ASSESSMENTS = 'assessments',
	PLANNING = 'planning',
	TEST_RUN = 'testRun',
	LAUNCH = 'launch',
}

export const TABS = [
	{
		id: TAB_KEYS.ALL,
		icon: <BookOpenIcon label="" />,
		tagIcon: <BookOpenIcon label="" size="small" />,
		text: messages.tabPillAllText,
	},
	{
		id: TAB_KEYS.ASSESSMENTS,
		icon: <CompassIcon label="" />,
		tagIcon: <CompassIcon label="" size="small" />,
		text: messages.tabPillAssessmentsText,
	},
	{
		id: TAB_KEYS.PLANNING,
		icon: <RoadmapsPlanIcon label="" />,
		tagIcon: <RoadmapsPlanIcon label="" size="small" />,
		text: messages.tabPillPlanningText,
	},
	{
		id: TAB_KEYS.TEST_RUN,
		icon: <CustomizeIcon label="" />,
		tagIcon: <CustomizeIcon label="" size="small" />,
		text: messages.tabPillTestRunText,
	},
	{
		id: TAB_KEYS.LAUNCH,
		icon: <ProjectIcon label="" />,
		tagIcon: <ProjectIcon label="" size="small" />,
		text: messages.tabPillLaunchText,
	},
];

// IMPORTANT: Update the confluence mapping table if new links are added
// Mapping table: https://hello.atlassian.net/wiki/spaces/CT5/pages/5830006610/Analytics+Proposal+-+Fastshift+Portal+Milestone+2#Appendix
export const RESOURCE_LINK_CARDS: ResourceLinkCardProps[] = [
	{
		id: 'portfolio_insights',
		heading: messages.card1Heading,
		description: messages.card1Description,
		category: TAB_KEYS.ASSESSMENTS,
		link: {
			linkText: messages.linkText,
			href: 'https://support.atlassian.com/portfolio-insights/docs/about-portfolio-insights/',
		},
	},
	{
		id: 'detect_and_connect_to_your_portfolio',
		heading: messages.card2Heading,
		description: messages.card2Description,
		category: TAB_KEYS.ASSESSMENTS,
		link: {
			linkText: messages.linkText,
			href: 'https://support.atlassian.com/portfolio-insights/docs/detect-and-connect-to-your-portfolio/',
		},
	},
	{
		id: 'assess_jira_cloud_readiness',
		heading: messages.card3Heading,
		description: messages.card3Description,
		category: TAB_KEYS.ASSESSMENTS,
		link: {
			linkText: messages.linkText,
			href: 'https://confluence.atlassian.com/support/assess-your-instance-scale-using-jira-cloud-migration-assistant-database-queries-and-usage-metrics-1267761445.html',
		},
	},
	{
		id: 'assess_confluence_cloud_readiness',
		heading: messages.card4Heading,
		description: messages.card4Description,
		category: TAB_KEYS.ASSESSMENTS,
		link: {
			linkText: messages.linkText,
			href: 'https://confluence.atlassian.com/support/assess-your-instance-scale-using-confluence-cloud-migration-assistant-database-queries-and-usage-metrics-1318881830.html',
		},
	},
	{
		id: 'compare_cloud_migration_methods',
		heading: messages.card5Heading,
		description: messages.card5Description,
		category: TAB_KEYS.PLANNING,
		link: {
			linkText: messages.linkText,
			href: 'https://support.atlassian.com/migration/docs/compare-cloud-migration-methods/',
		},
	},
	{
		id: 'milestone_tracker_template',
		heading: messages.card6Heading,
		description: messages.card6Description,
		category: TAB_KEYS.PLANNING,
		link: {
			linkText: messages.linkText,
			href: 'https://support.atlassian.com/migration/docs/milestone-tracker/',
		},
	},
	{
		id: 'fastshift_stages_and_data_handling',
		heading: messages.card7Heading,
		description: messages.card7Description,
		category: TAB_KEYS.PLANNING,
		link: {
			linkText: messages.linkText,
			href: 'https://support.atlassian.com/migration/docs/fastshift-migration-stages-and-data-handling/',
		},
	},
	{
		id: 'roles_and_responsibilities',
		heading: messages.card8Heading,
		description: messages.card8Description,
		category: TAB_KEYS.PLANNING,
		link: {
			linkText: messages.linkText,
			href: 'https://support.atlassian.com/migration/docs/roles-and-responsibilities-in-the-migration-process/',
		},
	},
	{
		id: 'issue_tracker',
		heading: messages.card9Heading,
		description: messages.card9Description,
		category: TAB_KEYS.TEST_RUN,
		link: {
			linkText: messages.linkText,
			href: 'https://support.atlassian.com/migration/docs/issue-tracker/',
		},
	},
	{
		id: 'cloud_migration_runbook',
		heading: messages.card10Heading,
		description: messages.card10Description,
		category: TAB_KEYS.TEST_RUN,
		link: {
			linkText: messages.downloadText,
			href: 'https://www.atlassian.com/dam/jcr:5451577b-91c9-4fc8-97f2-765ab8e89114/Cloud%20Migration%20Runbook%20Template.xlsx',
		},
	},
	{
		id: 'link_fixing',
		heading: messages.card11Heading,
		description: messages.card11Description,
		category: TAB_KEYS.LAUNCH,
		link: {
			linkText: messages.linkText,
			href: 'https://support.atlassian.com/migration/docs/what-are-product-links/',
		},
	},
	{
		id: 'macro_repair',
		heading: messages.card12Heading,
		description: messages.card12Description,
		category: TAB_KEYS.LAUNCH,
		link: {
			linkText: messages.linkText,
			href: 'https://confluence.atlassian.com/confkb/using-the-jira-macro-repair-1084362152.html',
		},
	},
];

// IMPORTANT: Update the confluence mapping table if new links are added
// Mapping table: https://hello.atlassian.net/wiki/spaces/CT5/pages/5830006610/Analytics+Proposal+-+Fastshift+Portal+Milestone+2#Appendix
export const USEFUL_LINKS = [
	{
		id: 'partner_portal',
		icon: <BookWithBookmarkIcon label="" spacing="spacious" />,
		text: messages.partnerPortalLinkText,
		href: 'https://partnercentral.atlassian.com/get-started',
	},
	{
		id: 'billing_console',
		icon: <CreditCardIcon label="" spacing="spacious" />,
		text: messages.billingConsoleLinkText,
		href: 'https://admin.atlassian.com/billing',
	},
	{
		id: 'migration_support',
		icon: <SupportIcon label="" spacing="spacious" />,
		text: messages.migrationSupportLinkText,
		href: 'https://support.atlassian.com/',
	},
];
